import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import url from "url/index";
import { getAuthToken } from "helpers/authToken";
import { setHostname } from "utils/hostname";
import { setHeaders } from "utils/credential";
import { setBannerList } from "./slice";
import { CarouselSlideTypeResponseType } from "../../types/Banners";

export const bannerApi = createApi({
  reducerPath: "bannerApi",
  baseQuery: fetchBaseQuery({
    baseUrl: setHostname(),
    prepareHeaders: setHeaders,
  }),
  endpoints: (build) => ({
    bannerList: build.query<CarouselSlideTypeResponseType, string>({
      query: () => ({
        headers: getAuthToken(),
        url: url.config.api.banners.root,
      }),
      // async onQueryStarted(request: string, { dispatch, queryFulfilled, getState }) {
      //     const { data } = await queryFulfilled;
      //     if (data.statusCode === 200) {
      //         dispatch(setBannerList(data.banners));
      //     }
      // },
      async onQueryStarted(request: string, { dispatch, queryFulfilled }) {
        const { meta, data } = await queryFulfilled;
        if (meta?.response?.status === 200) {
          dispatch(setBannerList(data));
        }
      },
    }),
  }),
});
